import styled from "styled-components";

// TEXT

// STYLES
export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  padding: 0.5rem;
  justify-content: flex-end;
`;

// DATA

// TYPES

// CONSTANTS

// FUNCTIONS

// ASSETS
